export const initialAbility = [
  {
    action: 'read',
    subject: 'Auth',
  },
  {
    action: 'read',
    subject: 'guest-trainings.index',
  },
]

export const _ = undefined
